module.exports = __webpack_public_path__ + "static/media/ke.732c2b39.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ke.svg
// module id = 857
// module chunks = 0